export default {
  type: "object",
  properties: {
    label: {
      type: "integer",
      description: "size marking",
      example: 32
    },
    sub_label: {
      type: "string|null",
      description: "size submarking",
      example: "null"
    },
    description: {
      type: "string|null",
      description: "marking and submarking in other markings",
      example: "UK 5,5 US 6,5"
    },
    primary_label_index: {
      type: "integer|null",
      description: "primary marking for size table",
      example: "2"
    },
    labels: {
      type: "array",
      items: {
        $ref: "#/components/schemas/sizeMarking",
        description: "other supported marking"
      }
    },
    recommended: {
      type: "boolean",
      description: "this size is recommended (best fit)"
    },
    fit: {
      type: "array",
      items: {
        $ref: "#/components/schemas/sizeAdvisorFit"
      }
    }
  }
};
